/**
 * URL absoluta del perfil público (misma que copian banda/cofradía desde su pestaña perfil).
 * @param {'banda' | 'cofradia'} entityType
 * @param {string} [entityId]
 */
export function buildPublicProfileShareUrl(entityType, entityId) {
  if (!entityId) return '';
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const path = entityType === 'banda' ? '/ver-perfil-banda' : '/ver-perfil-cofradia';
  return `${origin}${path}?id=${encodeURIComponent(String(entityId))}`;
}
